import { render, staticRenderFns } from "./bindEdit.vue?vue&type=template&id=2bc151df&scoped=true&"
import script from "./bindEdit.vue?vue&type=script&lang=js&"
export * from "./bindEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc151df",
  null
  
)

export default component.exports